import { useCreateUserPromptResponseMutation as useCreateUserPromptResponse } from '../types'
export default useCreateUserPromptResponse
